import * as React from "react";
import Image from "next/image";
import styles from "./styles.module.css";
import MailingList from "./MailingList";
import ArticleAuthor from "./ArticleAuthor";
import BroadbandDeals from "./BroadbandDeals";
import TableOfContents from "./TableOfContents";
import RelatedArticles from "./RelatedArticles";
import { BLOCKS } from "@contentful/rich-text-types";
import { NodeRenderer } from "@contentful/rich-text-react-renderer";
import { Article as ArticleType, TableOfContentsType } from "@/types/index";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const Article: React.FC<{
	article: ArticleType;
	relatedArticles?: Array<ArticleType>;
	showAuthor?: Boolean;
	showSideBar?: Boolean;
	showCallout?: Boolean;
}> = ({
	article,
	relatedArticles,
	showAuthor = true,
	showSideBar = true,
	showCallout = false,
}) => {
	const formatDate = (datetime: string) => {
		const date = new Date(datetime);

		return date.toLocaleDateString("en-US", {
			weekday: "long",
			year: "numeric",
			month: "long",
			day: "numeric",
		});
	};

	const extractHeadings = (body: any) => {
		const headings: TableOfContentsType = [];

		const renderNode: { [key: string]: NodeRenderer } = {
			[BLOCKS.HEADING_2]: (node: any, children: any) => {
				const headingText = node.content[0].value;
				const id = headingText.toLowerCase().replace(/\s+/g, "-");

				headings.push({
					id: id,
					text: headingText.replace(":", "."),
				});

				return <h2 id={id}>{children}</h2>;
			},
		};

		documentToReactComponents(body, { renderNode });

		return headings;
	};

	const headings = extractHeadings(article.fields.body);

	return (
		<section className={`${styles.article} pt-5 pb-5`}>
			<div className="container">
				<div className="row">
					{showAuthor && (
						<div className="row mb-5">
							<div className="col">
								<ArticleAuthor
									author={article.fields.author}
									lastUpdated={formatDate(article.sys.updatedAt)}
								/>
							</div>
						</div>
					)}
					<div className={`col-12 col-lg-3 order-lg-last ${styles.sticky}`}>
						{showSideBar && (
							<div className={`mb-5 ms-2 ${styles.sidebar}`}>
								{relatedArticles && (
									<RelatedArticles
										title="Related Articles"
										articles={relatedArticles}
									/>
								)}

								<MailingList />
							</div>
						)}

						<TableOfContents headings={headings} />
					</div>
					<div className="col-12 col-lg-9">
						<div className="row">
							{/* <div className={`col-12 col-lg-3 order-lg-last ${styles.sticky}`}>
								<TableOfContents headings={headings} />
							</div> */}
							<div className={`col-lg-8" ${styles.article__body}`}>
								{article.fields.banner && (
									<div className="mb-5">
										<Image
											width={
												article.fields.banner.fields.file?.details.image?.width
											}
											height={
												article.fields.banner.fields.file?.details.image?.height
											}
											layout="responsive"
											objectFit="contain"
											alt={article.fields.banner.fields.description ?? ""}
											src={`https:${article.fields.banner.fields.file?.url}`}
											priority={true}
										/>
									</div>
								)}
								{documentToReactComponents(article.fields.body, {
									renderNode: {
										[BLOCKS.HEADING_2]: (node: any, children: any) => {
											const headingText = node.content[0].value;
											const id = headingText.toLowerCase().replace(/\s+/g, "-");

											return <h2 id={id}>{children}</h2>;
										},
										[BLOCKS.EMBEDDED_ASSET]: (node) => (
											<Image
												width={
													node.data?.target?.fields?.file?.details?.image?.width
												}
												height={
													node.data?.target?.fields?.file?.details?.image
														?.height
												}
												src={`https:${node.data?.target?.fields?.file?.url}`}
												alt={node.data?.target?.fields?.title}
											/>
										),
									},
								})}
								{showCallout && <BroadbandDeals />}
							</div>
						</div>
					</div>
					{showSideBar && (
						<div className={`me-2 mt-4 ${styles.sidebar2}`}>
							{relatedArticles && (
								<RelatedArticles
									title="Related Articles"
									articles={relatedArticles}
								/>
							)}

							<MailingList />
						</div>
					)}
				</div>
			</div>
		</section>
	);
};

export default Article;
